import { useQueryParamHelper } from '@shared/core/queryString';
import { HONEYMOON_SEARCH_PARAM, HONEYMOON_SEARCH_PARAM_VALUE } from '@shared/constants/honeymoonFundSearch';

/**
 * True when the couple reached this search from a cash-fund banner in admin registry, rather
 * than from the accommodations pages.
 *
 * Read from a param the banners stamp, so the search page can tell the two entry points apart —
 * it cannot otherwise, because the cash-fund console is chosen from the couple's experiment and
 * balance, not from where they came from.
 *
 * Deliberately not the UTM campaign: inbound acquisition UTM is merged over the internal slots,
 * so a couple arriving on admin from a marketing link would lose the behaviour silently.
 */
export const useIsHoneymoonFundSearch = (): boolean => {
  const queryParamHelper = useQueryParamHelper();

  return queryParamHelper.getValueString(HONEYMOON_SEARCH_PARAM) === HONEYMOON_SEARCH_PARAM_VALUE;
};
